'use strict';
var runtimeHelper = require('./runtimeHelper');
var envHelper = require('./envHelper');

var cn = {
  LOADING: '数据载入中...',
  FAIL_TO_LOAD: '抱歉，加载数据失败。',
  REMOTE_1: '错误：不能直接在本地打开此页面, 如果你需要在本地预览, 请',
  REMOTE_2: '查看 ',
  REMOTE_3: '。',
  REMOTE_4: '如需帮助请查看',
  ALWAYS_SHOW_LINK: '始终显示链接',
  HOVER_SHOW_LINK: '鼠标滑过时，显示链接',
  HOVER_SHOW_REMARK: '鼠标滑过时，显示备注',
  SHOW_REMARKS: '显示批注',
  SETTINGS: '控制面板',
  RIGHT_PANEL: runtimeHelper.canReview() ? '评论及备注' : '备注',
  HOME: '首页',
  PREV: '后退',
  NEXT: '前进',
  PLAYBACK: '回放',
  QRCODE: '推荐使用微信扫码',
  ERROR: '错误：',
  HELP: '',
  INSTALL: '添加到主屏幕',
  CLICK_DOWN: '请点击屏幕下方的',
  CLICK_DOWN2: '',
  ADD_HOME: '选择“添加到主屏幕”',
  CLICK_MENU: '请点击屏幕右上角菜单',
  SKIP_INSTALL: '添加后可以获得最佳体验。暂时不想添加？',
  OPEN_NOW: '直接打开',
  OPEN_IN_SAFARI: '选择“在Safari中打开”',
  SITE_MAP_ERROR: '哦嗬，出错了！\n\u00a0\n站点地图的节点配置不正确，你应该像这样配置：\n\u00a0\n首页\n-公司\n-产品...',
  NOT_AVAILABLE_ON_MOBILE: '不支持在移动设备上查看此项目。',
  ENTER_PASSWORD: '请输入访问密码',
  PASSWORD: '访问密码',
  VALIDATE: '验证',
  PASSWORD_CANNOT_BE_EMPTY: '密码不能为空。',
  WRONG_PASSWORD: '密码错误。',
  RIGHT_PASSWORD: '验证成功。',

  COMMENT_HINT: '说点什么...',
  SIGN_HINT: '请输入你的名字',
  SIGN_LABEL: '签名',
  SUBMIT: '发表',
  ENTER_SIGN: '请输入签名后再评论。',
  BUTTON_SURE: '确定',
  NO_REMARK: '暂无备注。',
  NO_REVIEW: '暂无审阅信息。',
  PAINT_TIP: '标注了页面。',
  REVIEW_LOADING: '正在加载...',
  NET_ERROR: '网络错误。',
  LOAD_REVIEW_FAILED: '加载数据失败。',
  SIGN_ALERT_MSG: '请输入你的签名',
  SIGN_TIP: '*此签名用于识别团队成员。',
  SAVING: '正在保存数据...',
  SAVE_ALERT_MSG: '你还有修改未保存，是否保存？',
  BUTTON_SAVE: '保存',
  BUTTON_CANCEL: '放弃',
  SAVE_FAILED_MSG: '条数据保存失败！',

  REMARK: '备注',
  COMMENT: '评论',
  VIEW_COMMENT: '查看评论',
  VIEW_MARK: '查看标注',
  HIDDEN_MARK: '隐藏标注',

  MARK: '标注',

  IMAGE: '图片',

  COPIED_PAGE_LINK: '当前页面的链接已复制。',
  REQUEST_SOURCE_ERROR: '加载资源失败，请检查你的网络连接，建议将 DNS 设置为 223.5.5.5 然后重试。'
};

var en = {
  LOADING: 'Loading...',
  FAIL_TO_LOAD: 'Sorry, failed to load data.',
  REMOTE_1: 'Error: This page cannot be opened directly from local. If you would like to preview it offline, please ',
  REMOTE_2: 'view ',
  REMOTE_3: '.',
  REMOTE_4: 'Read this for help',
  ALWAYS_SHOW_LINK: 'Always show link',
  HOVER_SHOW_LINK: 'Show link when mouse over',
  HOVER_SHOW_REMARK: 'Show remark when mouse over',
  SHOW_REMARKS: 'Show markup',
  SETTINGS: 'Control panel',
  RIGHT_PANEL: runtimeHelper.canReview() ? 'Comment & Remark' : 'Remark',
  HOME: 'Home',
  PREV: 'Back',
  NEXT: 'Forward',
  PLAYBACK: 'Playback',
  QRCODE: 'Scan QR code to view on mobile',
  ERROR: 'Error:',
  HELP: 'If you need assistance, please shoot us an email at support@jongde.com.',
  INSTALL: 'Install This Prototype',
  CLICK_DOWN: 'Tap the below share button',
  CLICK_DOWN2: '',
  ADD_HOME: 'Then choose “Add to Home Screen”',
  CLICK_MENU: 'Tap the menu at the upper right corner',
  SKIP_INSTALL: 'Install now to get the best experience. Install later?',
  OPEN_NOW: 'Open directly',
  OPEN_IN_SAFARI: 'Then choose “Open in Safari”',
  SITE_MAP_ERROR: 'Errors!\n\u00a0\nNodes configured for site map are false and you should configure therm as follows:\n\u00a0\nHome\n-Company\n-Product...',
  NOT_AVAILABLE_ON_MOBILE: 'This project cannot be viewed on mobile device.',
  ENTER_PASSWORD: 'Please enter password',
  PASSWORD: 'Password',
  VALIDATE: 'Validate',
  PASSWORD_CANNOT_BE_EMPTY: 'Password can\'t be empty.',
  WRONG_PASSWORD: 'Wrong password, please try again.',
  RIGHT_PASSWORD: 'Verified successfully!',
  COMMENT_HINT: 'Write down your comments...',
  SIGN_HINT: 'Please enter your name',
  SIGN_LABEL: 'Name',
  SUBMIT: 'Submit',
  ENTER_SIGN: 'Please enter your name before submitting the comment. ',
  BUTTON_SURE: 'OK',
  NO_REMARK: 'No remark now.',
  NO_REVIEW: 'No review information now.',
  PAINT_TIP: 'Marked up the page.',
  REVIEW_LOADING: 'Loading...',
  NET_ERROR: 'Network Error.',
  LOAD_REVIEW_FAILED: 'Failed to load data.',
  SIGN_ALERT_MSG: 'Please enter your name',
  SIGN_TIP: '*This name is used to identify the team member. ',
  SAVING: 'Saving...',
  SAVE_ALERT_MSG: 'Some changes haven\'t been saved. Save now?',
  BUTTON_SAVE: 'Save',
  BUTTON_CANCEL: 'Cancel',
  SAVE_FAILED_MSG: ' piece(s) of data failed to save!',
  REMARK: 'Remark',
  COMMENT: 'Comment',
  VIEW_COMMENT: 'View comment',
  VIEW_MARK: 'Show markup',
  HIDDEN_MARK: 'Hide markup',
  MARK: 'Markup',
  IMAGE: 'Image',
  COPIED_PAGE_LINK: 'The current page link was copied.',
  REQUEST_SOURCE_ERROR: 'Failed to load data. Please check your network connection. It is recommended to set your DNS to 8.8.8.8 and try again.'
};

var jp = {
  LOADING: 'データを読み込み中...',
  FAIL_TO_LOAD: '申し訳ございませんが、データの読み込みに失敗しました。',
  REMOTE_1: 'エラー：ローカルでこのページを開くことができないため、ローカルでプレビューしたい場合、次を',
  REMOTE_2: 'チェックしてください ',
  REMOTE_3: '。',
  REMOTE_4: 'ヘルプが必要である場合、次をチェックしてください',
  ALWAYS_SHOW_LINK: 'リンクを常時に表示',
  HOVER_SHOW_LINK: 'マウスオーバーの場合は、リンクを表示',
  HOVER_SHOW_REMARK: 'マウスオーバーの場合は、備考を表示',
  SHOW_REMARKS: 'コメントを表示',
  SETTINGS: 'コントロールパネル',
  RIGHT_PANEL: runtimeHelper.canReview() ? 'コメントおよび備考' : '備考',
  HOME: 'ホームページ',
  PREV: '前のページ',
  NEXT: '次のページ',
  PLAYBACK: 'プレイバック',
  QRCODE: '二次元コードをスキャンして、携帯にチェックしてください',
  ERROR: 'エラー：',
  HELP: '',
  INSTALL: 'このアプリをインストール',
  CLICK_DOWN: '画面下部にある',
  CLICK_DOWN2: 'をクリックしてください',
  ADD_HOME: '「メインスクリーンに追加」を選択',
  CLICK_MENU: 'スクリーンの右上にあるメニューをクリックしてください',
  SKIP_INSTALL: 'インストール後にベスト体験を受けることができます。まだインストールを決めていない場合',
  OPEN_NOW: '直接開く',
  OPEN_IN_SAFARI: '「Safariで開く」を選択',
  SITE_MAP_ERROR: 'あら、エラーが発生ました！\n\u00a0\nサイト地図のノードは正しく配置しない、次のように配置される必要があります：\n\u00a0\nホームページ\n-会社\n-製品...',
  NOT_AVAILABLE_ON_MOBILE: 'モバイルディバイスでこのプロジェクトをチェックすることはサポートされません。',
  ENTER_PASSWORD: 'パスワードを入力してください',
  PASSWORD: 'パスワード',
  VALIDATE: '認証',
  PASSWORD_CANNOT_BE_EMPTY: 'パスワードは空欄にできません。',
  WRONG_PASSWORD: 'パスワードが間違っています。',
  RIGHT_PASSWORD: '認証成功。',
  COMMENT_HINT: '何か言ってみましょう...',
  SIGN_HINT: 'お名前を入力してください',
  SIGN_LABEL: 'サイン',
  SUBMIT: '提出',
  ENTER_SIGN: 'サインを入力してから、コメントをしてください。',
  BUTTON_SURE: '確定',
  NO_REMARK: '備考はありません。',
  NO_REVIEW: 'レビューはありません。',
  PAINT_TIP: 'ページをマークしました。',
  REVIEW_LOADING: '読み込み中...',
  NET_ERROR: 'ネットワークエラー。',
  LOAD_REVIEW_FAILED: 'データの読み込みに失敗しました。',
  SIGN_ALERT_MSG: 'あなたのサインを入力してください',
  SIGN_TIP: '*このサインはチームメンバの識別に使用されます。',
  SAVING: 'データ保存中...',
  SAVE_ALERT_MSG: '未保存の修正データがあります。保存しますか？',
  BUTTON_SAVE: '保存',
  BUTTON_CANCEL: '取り消す',
  SAVE_FAILED_MSG: 'データ保存に失敗しました！',
  REMARK: '備考',
  COMMENT: 'コメント',
  VIEW_COMMENT: 'コメントをチェック',
  VIEW_MARK: 'マークアップを表示',
  HIDDEN_MARK: 'マークアップを隠し',
  MARK: 'マークアップ',
  IMAGE: '画像',
  COPIED_PAGE_LINK: '現在ページのリンクがコピーされました。',
  REQUEST_SOURCE_ERROR: 'リソースの読み込みに失敗しました。ネットワークの接続をチェックしてください。DNS を 223.5.5.5 に設定してから再試行することをお勧めします。'
};

var LANGS = {
  cn: cn,
  jp: jp,
  en: en
};


var currentLang = LANGS[envHelper.lang];
if (!currentLang) {
  currentLang = LANGS.cn;
}

exports.get = function (n) {
  return currentLang[n];
};



// WEBPACK FOOTER //
// ./src/helper/i18n.js